import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import { observer, inject } from 'mobx-react';
import { action, observable } from 'mobx';
import moment from 'moment';
import Form, { FormBody, DateInput, SelectInput, FormActions } from '../Form';
import * as api from '../../actions/api';
import GraphView from '../GraphView';
import Spinner from '../Spinner';
import { getDisplayDate } from "../../libs/date";

@inject('stationStore', 'dataSeriesStore', 'parameterStore')
@observer
class AnalysisComparison extends Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    params: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
  };

  @observable filters = {
    station_id: null,
    series_id: null,
    station_id2: null,
    series_id2: null,
    date_from: moment().subtract(7, 'days').format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD'),
    period: 'Point',
  };
  @observable station = {};
  @observable stations = [];
  @observable observations = [];
  @observable observations2 = [];
  @observable dataSeriesItems = [];
  @observable dataSeriesItems2 = [];

  constructor(props) {
    super(props);

    this.state = {
      height: window.innerHeight,
      // product: '',
      series: 1, // props.seriesList[0].id,   // TODO Check if list is empty
      from: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      data: {
        data: [],
        categories: [],
        seriesData: [],
      },
      data2: {
        data: [],
        categories: [],
        seriesData: [],
      },
      titleText: '',
      options: [],
      station1Available: false,
      station2Available: false,
      loading: false,
      unit: '',
      unit2: ''
    };
  }

  componentWillMount() {
    const { notify } = this.context;
    const { params: { id }, stationStore, dataSeriesStore, parameterStore } = this.props;

    parameterStore.fetchItems();
    stationStore.fetchItems()
      .then(action(stations => {
        this.stations = stations.sort((a, b) => (a.name > b.name) ? 1 : -1);
        // this.onChangeStationFilter({target: {value: 517}});
        // this.onChangeStationFilter2({target: {value: 517}});
      }))
      .catch(notify.error);
  }

  @action reset(item) {
    if (!item) { return; }
    this.observations = item;
  }
  @action reset2(item) {
    if (!item) { return; }
    this.observations2 = item;
  }

  @action onChangeStationFilter = (e) => {
    const { notify } = this.context;
    const { stationStore, parameterStore } = this.props;
    const stationId = e.target.value;
    this.filters.station_id = stationId;
    stationStore.fetchDataSeries(stationId)
      .then(action(dataSeriesItems => {
        this.dataSeriesItems = dataSeriesItems
          .sort((a, b) => a.name > b.name ? 1 : -1)
          .map(item => (Object.assign(item, { parameter: parameterStore.findById(item.parameter_id) })));
      }))
      .catch(notify.error);
  };
  @action onChangeSeries = (e) => { this.filters.series_id = e.target.value; }

  @action onChangeStationFilter2 = (e) => {
    const { notify } = this.context;
    const { stationStore, parameterStore } = this.props;
    const stationId = e.target.value;
    this.filters.station_id2 = stationId;
    if (parameterStore.items.length === 0) parameterStore.fetchItems();
    stationStore.fetchDataSeries(stationId)
      .then(action(dataSeriesItems => {
        this.dataSeriesItems2 = dataSeriesItems
          .sort((a, b) => a.name > b.name ? 1 : -1)
          .map(item => (Object.assign(item, { parameter: parameterStore.findById(item.parameter_id) })));
      }))
      .catch(notify.error);
  };
  @action onChangeSeries2 = (e) => { this.filters.series_id2 = e.target.value; }

  @action onChangePeriodFilter = (e) => { this.filters.period = e.target.value; }
  @action onChangeParameter = (e) => { this.filters.parameterId = e.target.value; }
  @action onChangeDateFrom = (e) => { this.filters.date_from = e.target.value; }
  @action onChangeDateTo = (e) => { this.filters.date_to = e.target.value; }
  @action showObservations = (e) => {
    const { notify } = this.context;
    const { stationStore, parameterStore } = this.props;
    e.preventDefault();

    const er = message => notify.error({ message });
    if (!this.filters.station_id || !this.filters.station_id2) { return er('Station filter required'); }
    if (!this.filters.series_id || !this.filters.series_id2) { return er('Data Series filter required'); }
    if (!this.filters.date_from) { return er('Start date filter required'); }
    if (!this.filters.date_to) { return er('End date filter required'); }
    this.setState({ options: [] });
    this.setState({ station1Available: false });
    this.setState({ station2Available: false });
    this.setState({ loading: true });

    let station1 = {
      station_id: this.filters.station_id,
      series_id: this.filters.series_id,
      date_from: this.filters.date_from,
      date_to: this.filters.date_to,
      period: this.filters.period
    };
    let station2 = {
      station_id: this.filters.station_id2,
      series_id: this.filters.series_id2,
      date_from: this.filters.date_from,
      date_to: this.filters.date_to,
      period: this.filters.period
    };

    api.analysis
      .fetchAll(station1)
      .then((observations) => {
        observations.data = (() => {
          if (!observations.data || observations.data.length == 0) return observations.data;
          let groupedObservation = _.groupBy(observations.data, item => item.datetime);
          let uniqueObservations = [];
          Object.keys(groupedObservation).map(item => {
            uniqueObservations.push(groupedObservation[item][0])
          });
          return uniqueObservations;
        })();
        this.reset(observations);

        const { date_from: dateFrom, date_to: dateTo, period: periodFilter } = this.filters;
        const parameter = this.dataSeriesItems.filter(item => item.name.toLowerCase() == observations.parameter_name.toLowerCase())[0];
        parameter && parameter.parameter_unit && parameter.parameter_unit.symbol ? this.setState({ unit: parameter.parameter_unit.symbol }) : this.setState({ unit: '' });
        let selectedParameterProperty = parameterStore.findById(this.dataSeriesItems.filter(item => item.id == this.filters.series_id)[0].parameter_id).property;
        let selectedParameterStartTime = this.dataSeriesItems.filter(item => item.id == this.filters.series_id)[0].start_time.split(':');

        const titleText = `${observations.parameter_name} (${stationStore.findById(station1.station_id).name})`.replace(/,/g, '-');

        const dataState = this.state.data;
        dataState.data = (
          observations.data && observations.data.map(observation => parseFloat(observation.value))
        ) || [];
        dataState.categories = (
          observations.data && observations.data.map(observation => observation.datetime)
        ) || [];

        const seriesData = (
          observations.data &&
          observations.data.map(({ datetime, value }) => {
            return [getDisplayDate(datetime, { returnMills: true }), value];
          })
        ) || [];

        let seriesOptions;

        if (periodFilter === 'Point') {
          seriesOptions = [{
            type: selectedParameterProperty === 'Accumulative' ? 'column' : 'line',
            name: titleText,
            data: seriesData,
            yAxis: 0,
            tooltip: {
              valueSuffix: this.state.unit
            }
          }];
        }
        else {
          const resolvePeriodFormat = p => {
            switch (p) {
              // case 'Point': return 'YYYY-MM-DDTHH:mm:ss+00:00';
              case 'Minute':
                return 'YYYY-MM-DDTHH:mm:00+00:00';
              case 'Hourly':
                return 'YYYY-MM-DDTHH:00:00+00:00';
              case 'Daily':
                return 'YYYY-MM-DDT00:00:00+00:00';
              case 'Weekly':
                return 'YYYY-MM-DDT00:00:00+00:00';
              // case 'Weekly':  return 'YYYY-MM-DDTHH:00:00+00:00';
              // case 'Weekly': return 'gggg ww';
              case 'Monthly':
                return 'YYYY-MM-01T00:00:00+00:00';
              case 'Annual':
                return 'YYYY-01-01T00:00:00+00:00';
              default:
                return 'YYYY-MM-DDTHH:mm:ss+00:00';
            }
          };

          // const periodFormat = resolvePeriodFormat(periodFilter);

          // const seriesDataPeriodic = _.groupBy(seriesData, item => moment.utc(item[0]).format(periodFormat));

          const seriesDataPeriodic = _.groupBy(seriesData, item => {
            // return moment.utc(item[0]).format(resolvePeriodFormat(periodFilter))
            if (periodFilter == 'Daily') {
              let date = item[0],
                // hour = +moment.utc(date).format('HH'),
                hour = new Date(date).getUTCHours(),
                // minute = +moment.utc(date).format('mm'),
                minute = new Date(date).getUTCMinutes(),
                startHour = +selectedParameterStartTime[0],
                startMinute = +selectedParameterStartTime[1],
                offSetHour = Math.floor(moment().utcOffset() / 60),
                offSetMinute = moment().utcOffset() % 60;

              // console.log(moment(date).format('YYYY-MM-DDTHH:mm:ss'), moment.utc(date).format('YYYY-MM-DDTHH:mm:ss'), hour)
              // console.log(hour, new Date(date).getHours())

              // console.log(hour, startHour, minute, startMinute)
              if ((hour < (startHour + offSetHour)) || (hour == (startHour + offSetHour) && minute < (startMinute + offSetMinute))) {
                // console.log(moment.utc(date).format('YYYY-MM-DD HH:mm'), moment.utc(moment.utc(date).subtract(1, 'days').format('YYYY-MM-DDT00:00:00+00:00')).add(selectedParameterStartTime[0], 'hours').format('YYYY-MM-DD HH:mm'));
                // console.log(moment.utc(date).format('YYYY-MM-DDTHH:mm:ss'), moment.utc(moment.utc(date).subtract(1, 'days').format('YYYY-MM-DDT00:00:00+00:00')).add(startHour+offSetHour, 'hours').add(startMinute+offSetMinute, 'minutes').format('YYYY-MM-DDTHH:mm:00+00:00'))
                return moment.utc(moment.utc(date).subtract(1, 'days').format('YYYY-MM-DDT00:00:00+00:00')).add(startHour + offSetHour, 'hours').add(startMinute + offSetMinute, 'minutes').format('YYYY-MM-DDTHH:mm:00+00:00')
              } else {
                // console.log(moment.utc(date).format('YYYY-MM-DDTHH:mm:ss'), moment.utc(moment.utc(date).format('YYYY-MM-DDT00:00:00+00:00')).add(startHour+offSetHour, 'hours').add(startMinute+offSetMinute, 'minutes').format('YYYY-MM-DDTHH:mm:00+00:00'))
                return moment.utc(moment.utc(date).format('YYYY-MM-DDT00:00:00+00:00')).add(startHour + offSetHour, 'hours').add(startMinute + offSetMinute, 'minutes').format('YYYY-MM-DDTHH:mm:00+00:00')
              }
            } else {
              return moment.utc(moment.utc(item[0])).format(resolvePeriodFormat(periodFilter))
            }
          });

          const max = {};
          const min = {};
          const mean = {};
          const sum = {};

          if (selectedParameterProperty === 'Continuous') {
            Object.keys(seriesDataPeriodic)
              .forEach(period => {
                const periodData = seriesDataPeriodic[period].map(item => item[1]);
                max[period] = _.max(periodData);
                min[period] = _.min(periodData);
                mean[period] = _.mean(periodData);
              });

            const maxSeries = Object.keys(max).map(period => ([moment.utc(period).valueOf(), max[period]]));
            const minSeries = Object.keys(min).map(period => ([moment.utc(period).valueOf(), min[period]]));
            const meanSeries = Object.keys(mean).map(period => ([moment.utc(period).valueOf(), mean[period]]));
            seriesOptions = [
              {
                name: titleText + ' - Max',
                data: maxSeries,
              },
              {
                name: titleText + ' - Min',
                data: minSeries,
              },
              {
                name: titleText + ' - Average',
                data: meanSeries,
              }
            ];
          } else {
            Object.keys(seriesDataPeriodic).forEach(period => {
              const periodData = seriesDataPeriodic[period].map(item => item[1]).filter(item => item != null);
              sum[period] = _.sum(periodData)
            });
            const sumSeries = Object.keys(sum).map(period => ([moment.utc(period).valueOf(), sum[period]]));

            seriesOptions = [
              {
                name: titleText + ' - Accumulated',
                data: sumSeries,
                type: 'column'
              }
            ]
          }
        }
        this.setState({
          data: dataState,
          titleText,
          seriesData
        });
        this.state.station2Available ? this.setState({ options: [seriesOptions, this.state.options[0]] }) : this.state.options.push(seriesOptions);
        this.setState({ station1Available: true });
        this.setState({ loading: !this.state.station2Available });
      })
      .catch(notify.error);

    api.analysis
      .fetchAll(station2)
      .then((observations) => {
        observations.data = (() => {
          if (!observations.data || observations.data.length == 0) return observations.data;
          let groupedObservation = _.groupBy(observations.data, item => item.datetime);
          let uniqueObservations = [];
          Object.keys(groupedObservation).map(item => {
            uniqueObservations.push(groupedObservation[item][0])
          });
          return uniqueObservations;
        })();
        this.reset2(observations);

        const { date_from: dateFrom, date_to: dateTo, period: periodFilter } = this.filters;

        const parameter = this.dataSeriesItems2.filter(item => item.name.toLowerCase() == observations.parameter_name.toLowerCase())[0];
        parameter && parameter.parameter_unit && parameter.parameter_unit.symbol ? this.setState({ unit2: parameter.parameter_unit.symbol }) : this.setState({ unit2: '' });
        let selectedParameterProperty = parameterStore.findById(this.dataSeriesItems2.filter(item => item.id == this.filters.series_id2)[0].parameter_id).property;
        let selectedParameterStartTime = this.dataSeriesItems2.filter(item => item.id == this.filters.series_id2)[0].start_time.split(':');

        const titleText = `${observations.parameter_name} (${stationStore.findById(station2.station_id).name})`.replace(/,/g, '-');

        const dataState = this.state.data2;
        dataState.data = (
          observations.data && observations.data.map(observation => parseFloat(observation.value))
        ) || [];
        dataState.categories = (
          observations.data && observations.data.map(observation => observation.datetime)
        ) || [];

        const seriesData = (
          observations.data &&
          observations.data.map(({ datetime, value }) => {
            return [getDisplayDate(datetime, { returnMills: true }), value];
          })
        ) || [];

        let seriesOptions;

        if (periodFilter === 'Point') {
          seriesOptions = [{
            type: selectedParameterProperty === 'Accumulative' ? 'column' : 'line',
            name: titleText,
            data: seriesData,
            yAxis: 1,
            tooltip: {
              valueSuffix: this.state.unit2
            }
          }];
        } else {
          const resolvePeriodFormat = p => {
            switch (p) {
              // case 'Point': return 'YYYY-MM-DDTHH:mm:ss+00:00';
              case 'Minute':
                return 'YYYY-MM-DDTHH:mm:00+00:00';
              case 'Hourly':
                return 'YYYY-MM-DDTHH:00:00+00:00';
              case 'Daily':
                return 'YYYY-MM-DDT00:00:00+00:00';
              case 'Weekly':
                return 'YYYY-MM-DDT00:00:00+00:00';
              // case 'Weekly':  return 'YYYY-MM-DDTHH:00:00+00:00';
              // case 'Weekly': return 'gggg ww';
              case 'Monthly':
                return 'YYYY-MM-01T00:00:00+00:00';
              case 'Annual':
                return 'YYYY-01-01T00:00:00+00:00';
              default:
                return 'YYYY-MM-DDTHH:mm:ss+00:00';
            }
          };
          //
          // const periodFormat = resolvePeriodFormat(periodFilter);
          //
          // const seriesDataPeriodic = _
          //   .groupBy(seriesData, item =>
          //     moment.utc(item[0]).format(periodFormat));

          const seriesDataPeriodic = _.groupBy(seriesData, item => {
            // return moment.utc(item[0]).format(resolvePeriodFormat(periodFilter))
            if (periodFilter == 'Daily') {
              let date = item[0],
                // hour = +moment.utc(date).format('HH'),
                hour = new Date(date).getUTCHours(),
                // minute = +moment.utc(date).format('mm'),
                minute = new Date(date).getUTCMinutes(),
                startHour = +selectedParameterStartTime[0],
                startMinute = +selectedParameterStartTime[1],
                offSetHour = Math.floor(moment().utcOffset() / 60),
                offSetMinute = moment().utcOffset() % 60;

              // console.log(moment(date).format('YYYY-MM-DDTHH:mm:ss'), moment.utc(date).format('YYYY-MM-DDTHH:mm:ss'), hour)
              // console.log(hour, new Date(date).getHours())

              // console.log(hour, startHour, minute, startMinute)
              if ((hour < (startHour + offSetHour)) || (hour == (startHour + offSetHour) && minute < (startMinute + offSetMinute))) {
                // console.log(moment.utc(date).format('YYYY-MM-DD HH:mm'), moment.utc(moment.utc(date).subtract(1, 'days').format('YYYY-MM-DDT00:00:00+00:00')).add(selectedParameterStartTime[0], 'hours').format('YYYY-MM-DD HH:mm'));
                // console.log(moment.utc(date).format('YYYY-MM-DDTHH:mm:ss'), moment.utc(moment.utc(date).subtract(1, 'days').format('YYYY-MM-DDT00:00:00+00:00')).add(startHour+offSetHour, 'hours').add(startMinute+offSetMinute, 'minutes').format('YYYY-MM-DDTHH:mm:00+00:00'))
                return moment.utc(moment.utc(date).subtract(1, 'days').format('YYYY-MM-DDT00:00:00+00:00')).add(startHour + offSetHour, 'hours').add(startMinute + offSetMinute, 'minutes').format('YYYY-MM-DDTHH:mm:00+00:00')
              } else {
                // console.log(moment.utc(date).format('YYYY-MM-DDTHH:mm:ss'), moment.utc(moment.utc(date).format('YYYY-MM-DDT00:00:00+00:00')).add(startHour+offSetHour, 'hours').add(startMinute+offSetMinute, 'minutes').format('YYYY-MM-DDTHH:mm:00+00:00'))
                return moment.utc(moment.utc(date).format('YYYY-MM-DDT00:00:00+00:00')).add(startHour + offSetHour, 'hours').add(startMinute + offSetMinute, 'minutes').format('YYYY-MM-DDTHH:mm:00+00:00')
              }
            } else {
              return moment.utc(moment.utc(item[0])).format(resolvePeriodFormat(periodFilter))
            }
          });

          const max = {};
          const min = {};
          const mean = {};
          const sum = {};

          if (selectedParameterProperty === 'Continuous') {
            Object.keys(seriesDataPeriodic)
              .forEach(period => {
                // console.log('period', period);
                const periodData = seriesDataPeriodic[period].map(item => item[1]).filter(item => item != null);
                // console.log('periodData', periodData);
                max[period] = _.max(periodData);
                min[period] = _.min(periodData);
                mean[period] = _.sum(periodData) / periodData.length;
              });
            const maxSeries = Object.keys(max)
              .map(period => ([moment.utc(period).valueOf(), max[period]]));
            const minSeries = Object.keys(min)
              .map(period => ([moment.utc(period).valueOf(), min[period]]));
            const meanSeries = Object.keys(mean)
              .map(period => ([moment.utc(period).valueOf(), mean[period]]));

            seriesOptions = [
              {
                name: titleText + ' - Max',
                data: maxSeries,
              },
              {
                name: titleText + ' - Min',
                data: minSeries,
              },
              {
                name: titleText + ' - Average',
                data: meanSeries,
              }
            ];
          } else {
            Object.keys(seriesDataPeriodic).forEach(period => {
              const periodData = seriesDataPeriodic[period].map(item => item[1]).filter(item => item != null);
              sum[period] = _.sum(periodData)
            });
            const sumSeries = Object.keys(sum).map(period => ([moment.utc(period).valueOf(), sum[period]]));

            seriesOptions = [
              {
                name: titleText + ' - Accumulated',
                data: sumSeries,
                type: 'column'
              }
            ]
          }
        }

        this.setState({
          data2: dataState,
          titleText,
          seriesData
        });
        this.state.options.push(seriesOptions);
        this.setState({ station2Available: true });
        this.setState({ loading: !this.state.station1Available });
      })
      .catch(notify.error);
  };

  @action exportCSV = (e) => {
    e.preventDefault();
    const { options } = this.state;
    let station1 = options[0],
      station2 = options[1];

    let csvHeader = 'datetime,';
    let csvContent = '';
    let fileName = `${station1[0].name} - ${station2[0].name}`.replace(/ - Max/g, '').replace(/ - Min/g, '').replace(/ - Average/g, '');

    let combinedObservations = [];

    station1.map(series => {
      csvHeader = csvHeader.concat(series.name + ',');
      series.data.map(item => {
        let datetime = moment.utc(item[0]).format('MM/DD/YYYY HH:mm:00'),
          value = !!item[1] || item[1] === 0 ? item[1] : '';
        combinedObservations.push({ datetime, value, name: series.name })
      })
    });

    station2.map(series => {
      csvHeader = csvHeader.concat(series.name + ',');
      series.data.map(item => {
        let datetime = moment.utc(item[0]).format('MM/DD/YYYY HH:mm:00'),
          value = !!item[1] || item[1] === 0 ? item[1] : '';
        combinedObservations.push({ datetime, value, name: series.name })
      })
    });

    let groupedCombinedObservations = _.groupBy(combinedObservations, item => item.datetime);

    Object.keys(groupedCombinedObservations).sort((a, b) => moment(a).valueOf() > moment(b).valueOf() ? 1 : -1).map(datetime => {
      let object = groupedCombinedObservations[datetime],
        line = [datetime],
        splitHeader = csvHeader.split(',');
      for (let i = 1; i < splitHeader.length; i++) {
        let series = splitHeader[i];
        let data = object.filter(item => item.name == series)[0];
        line[i] = data ? data.value : '';
      }
      // object.map(series => {
      //   line[splitHeader.indexOf(series.name)] = series.value;
      // });

      csvContent = csvContent.concat(line.join(',') + '\n');
    });

    let textToSave = csvHeader + '\n' + csvContent;

    let hiddenElement = document.createElement('a');
    let csvData = new Blob([textToSave], { type: 'text/csv' });
    hiddenElement.href = URL.createObjectURL(csvData);
    hiddenElement.target = '_blank';
    hiddenElement.download = `${fileName}.csv`;
    hiddenElement.click();
  };

  render() {
    const { station1Available, station2Available, options, loading } = this.state;
    const { parameterStore, stationStore } = this.props;
    let series = [];
    let title = station1Available && station2Available ? this.stations.filter(station => station.id == this.filters.station_id)[0].name + ' - ' + this.stations.filter(station => station.id == this.filters.station_id2)[0].name : '';
    options.length > 0 && options.map(option => option.map(object => series.push(object)));
    const option = {
      chart: {
        type: 'line',
        zoomType: 'x',
      },
      title: {
        text: ''
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          millisecond: '%H:%M:%S.%L',
          second: '%H:%M:%S',
          minute: '%H:%M',
          hour: '%H:%M',
          day: '%e. %b',
          week: '%e. %b',
          month: '%b \'%y',
          year: '%Y',
        },
      },
      yAxis: [{
        title: {
          text: this.state.unit,
        },
        startOnTick: false,
        endOnTick: false
      }, {
        title: {
          text: this.state.unit2,
        },
        opposite: true,
        startOnTick: false,
        endOnTick: false
      }],
      tooltip: {
        shared: true,
        valueDecimals: 3
      },
      series: series,
    };

    return (
      <div>
        <Form>
          <FormBody>
            <div className='inline-grid'>
              <div>
                <SelectInput
                  filter
                  label={'Station 1'}
                  value={this.filters.station_id}
                  fields={{ label: 'name', value: 'id' }}
                  options={this.stations}
                  onChange={this.onChangeStationFilter}
                  filterOptions={stationStore.filterStations}
                />
                <SelectInput
                  label={'Data Series 1'}
                  value={this.filters.series_id}
                  fields={{ label: 'name', value: 'id' }}
                  options={this.dataSeriesItems}
                  onChange={this.onChangeSeries}
                  filterOptions={(options, filterText) => parameterStore.filterParameters(options, filterText, 'parameter.code')}
                />
              </div>
              <div>
                <SelectInput
                  label={'Station 2'}
                  value={this.filters.station_id2}
                  fields={{ label: 'name', value: 'id' }}
                  options={this.stations}
                  onChange={this.onChangeStationFilter2}
                  filterOptions={stationStore.filterStations}
                />
                <SelectInput
                  label={'Data Series 2'}
                  value={this.filters.series_id2}
                  fields={{ label: 'name', value: 'id' }}
                  options={this.dataSeriesItems2}
                  onChange={this.onChangeSeries2}
                  filterOptions={(options, filterText) => parameterStore.filterParameters(options, filterText, 'parameter.code')}
                />
              </div>
            </div>
            <DateInput
              label={'Date From'}
              value={this.filters.date_from}
              onChange={this.onChangeDateFrom}
            />
            <DateInput
              label={'Date To'}
              value={this.filters.date_to}
              onChange={this.onChangeDateTo}
            />
            <SelectInput
              label={'Period'}
              value={this.filters.period}
              fields={{ label: 'name', value: 'name' }}
              options={[
                { name: 'Point' },
                { name: 'Minute' },
                { name: 'Hourly' },
                { name: 'Daily' },
                { name: 'Weekly' },
                { name: 'Monthly' },
                { name: 'Annual' },
              ]}
              onChange={this.onChangePeriodFilter}
            />
          </FormBody>
          <FormActions>
            <button onClick={this.showObservations}>View</button>
            <button onClick={this.exportCSV}>Download CSV</button>
          </FormActions>
        </Form>

        <div>
          {loading ? <Spinner /> : station1Available && station2Available && <GraphView options={option} />}
        </div>

      </div>
    );
  }
}

export default AnalysisComparison;



// WEBPACK FOOTER //
// ./src/components/Analysis/AnalysisComparison.js